import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()

export class GeneralGestionTercerosService {
    constructor(private http: HttpClient) { }

    updateAllCustomersOR(url, data){
        return this.http.post(url, data);
    }

    getCustomerOrHistory(url, data) {
        return this.http.post(url, data);
    }

    customerServiceAdd(_URL, parametros) {
        return this.http.post<any>(_URL, parametros);
    }
    getByCustomerCodeWithContacts(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomers(url, params) {
        return this.http.post<any>(url, params);
    }
    exportGDPRLogActivityCSVFileService(url, params) {
        return this.http.post<any>(url, params);
    }

    existsByFiscalCode(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomerPaises(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomerCategories(url, params) {
        return this.http.post<any>(url, params);
    }

    getCourtesies(url, params) {
        return this.http.post<any>(url, params);
    }

    getBankCodes(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomerExemption(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomerModePaid(url, params) {
        return this.http.post<any>(url, params);
    }

    getDiscountPR(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomerIdentification(url, params) {
        return this.http.post<any>(url, params);
    }

    getlaborDiscount(url, params) {
        return this.http.post<any>(url, params);
    }

    getAdministrativeCenterService(url, params) {
        return this.http.post<any>(url, params);
    }

    findAlphabeticalPaged(url, params) {
        return this.http.post<any>(url, params);
    }

    getDataAll(url, params) {
        return this.http.post<any>(url, params);
    }

    getDataVehicle(url, params) {
        return this.http.post<any>(url, params);
    }

    getByCapCode(url, params) {
        return this.http.post<any>(url, params);
    }

    getCustomerNotifications(url, params) {
        return this.http.post<any>(url, params);
    }

    undeleteCustomer(url, params) {
        return this.http.post<any>(url, params);
    }




}

